export default __webpack_public_path__ + "static/media/aboutApplication.28f3b183.svg";